import React from 'react';
import PropTypes from 'prop-types';
import { FaqListItem } from '../FaqListItem';
import { CtaButton } from '../CtaButton';
import { SectionIntro } from '../../atoms/SectionIntro';
import { StyledFaqList, Inner, List, ButtonWrapper } from './styles.js';

export const FaqList = ({ faqs, headline, subheadline, link }) => {
  return (
    <StyledFaqList>
      <SectionIntro headline={headline} subheadline={subheadline} />
      <Inner>
        <List>
          {faqs.map(faq => (
            <FaqListItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </List>
        {link && (
          <ButtonWrapper>
            <CtaButton variant="dark" href={link.target}>
              {link.text}
            </CtaButton>
          </ButtonWrapper>
        )}
      </Inner>
    </StyledFaqList>
  );
};

FaqList.displayName = 'FaqList';

FaqList.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    }),
  ).isRequired,
  headline: PropTypes.string.isRequired,
  subheadline: PropTypes.string.isRequired,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }),
};
